// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2BxEm","fileBtn":"File_fileBtn__1G14L","closeBtn":"File_closeBtn__1z0qo","fileSelected":"File_fileSelected__36mqj","disabled":"File_disabled__2HiM8"};